import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useField } from "formik";
import { useButtonGroup } from "./useButtonGroup";
import classnames from "classnames";
const ButtonGroupItem = (props) => {
    const context = useButtonGroup();
    const [field] = useField(context.name);
    const fieldId = `${context.name}-${props.value}`;
    const className = classnames([
        "btn button-group-btn-item",
        { active: field.value === props.value },
        props.className,
    ]);
    return (_jsxs("label", { className: className, children: [_jsx("input", { ...field, type: "radio", id: fieldId, autoComplete: "off", value: props.value, disabled: props.disabled }), props.children] }));
};
export default ButtonGroupItem;
